import { fetchApi, type GenericRes } from '@hunk/shared/api/fetchApi';
import type { RoleType } from '@hunk/shared/common';
import type { PublicUserEntity } from '@hunk/shared/schema';

export type GetMyInfoReq = {};
export interface GetMyInfoRes extends GenericRes {
  user?: PublicUserEntity;
  role?: RoleType;
}

export const getMyInfo = ({ headers }: { headers?: HeadersInit }) => fetchApi<GetMyInfoReq, GetMyInfoRes>({ apiPath: '/api/self/getMyInfo', method: 'GET', headers });
